export const tabs = [
  { id: "1", title: "All", type: "all" },
  { id: "2", title: "Draft", type: "CREATED" },
  { id: "3", title: "Requested", type: "Requested" },
  {
    id: "4",
    title: "Submitted",
    type: "awaiting-approval,rejected-by-contractor",
  },
  {
    id: "5",
    title: "Pending Action",
    type: "awaiting-contractor-confirmation,open-for-modification",
  },
  {
    id: "6",
    title: "Approved",
    type: "proposed-to-client,approved-by-contractor",
  },
];

export default tabs;

// export const statusStyleArray = [
//   {
//     status: "draft",
//     color: "#d46b08",
//     backgroundColor: "#fff7e6",
//   },
//   {
//     status: "draft-by-contractor",
//     color: "#d46b08",
//     backgroundColor: "#fff7e6",
//   },
//   {
//     status: "Requested",
//     backgroundColor: "#c41d7f",
//     color: "#fff0f6",
//   },
//   {
//     status: "awaiting-approval",
//     color: "#d4b106",
//     backgroundColor: "#feffe6",
//   },
//   {
//     status: "awaiting-contractor-confirmation",
//     color: "#c41d7f",
//     backgroundColor: "#fff0f6",
//   },
//   {
//     status: "approved-by-contractor",
//     backgroundColor: "#d46b08",
//     color: "#fff7e6",
//   },
//   {
//     status: "rejected-by-contractor",
//     color: "rgb(229, 71, 70)",
//     backgroundColor: "#fff0f6",
//   },
//   {
//     status: "proposed-to-client",
//     color: "#fff",
//     backgroundColor: "rgb(56, 158, 13)",
//   },
//   {
//     status: "completed",
//     color: "#f6ffed",
//     backgroundColor: "#2e6f40",
//   },
//   {
//     status: "in_warranty",
//     color: "#fff",
//     backgroundColor: "#c292fd",
//   },
//   {
//     status: "ongoing",
//     color: "#096dd9",
//     backgroundColor: "#e6f7ff",
//   },
//   {
//     status: "delivered",
//     color: "#389e0d",
//     backgroundColor: "#f6ffed",
//   },
// ];
export const statusStyleArray = [
  // {
  //   status: "draft",
  //   color: "#d46b08",
  //   backgroundColor: "#fff7e6",
  // },
  // {
  //   status: "draft-by-contractor",
  //   color: "#d46b08",
  //   backgroundColor: "#fff7e6",
  // },
  // {
  //   status: "Requested",
  //   backgroundColor: "#c41d7f",
  //   color: "#fff0f6",
  // },
  // {
  //   status: "awaiting-approval",
  //   color: "#d4b106",
  //   backgroundColor: "#feffe6",
  // },
  // {
  //   status: "awaiting-contractor-confirmation",
  //   color: "#c41d7f",
  //   backgroundColor: "#fff0f6",
  // },
  // {
  //   status: "approved-by-contractor",
  //   backgroundColor: "#d46b08",
  //   color: "#fff7e6",
  // },
  // {
  //   status: "rejected-by-contractor",
  //   color: "rgb(229, 71, 70)",
  //   backgroundColor: "#fff0f6",
  // },
  // {
  //   status: "proposed-to-client",
  //   color: "#fff",
  //   backgroundColor: "rgb(56, 158, 13)",
  // },
  // {
  //   status: "completed",
  //   color: "#f6ffed",
  //   backgroundColor: "#2e6f40",
  // },
  // {
  //   status: "in_warranty",
  //   color: "#fff",
  //   backgroundColor: "#c292fd",
  // },
  // {
  //   status: "ongoing",
  //   color: "#096dd9",
  //   backgroundColor: "#e6f7ff",
  // },
  // {
  //   status: "delivered",
  //   color: "#389e0d",
  //   backgroundColor: "#f6ffed",
  // },
  {
    status: "draft",
    backgroundColor: "#d46b08",
  },
  {
    status: "draft-by-contractor",
    backgroundColor: "#d46b08",
  },
  {
    status: "Requested",
    backgroundColor: "#c41d7f",
  },
  {
    status: "awaiting-approval",
    backgroundColor: "#d4b106",
  },
  {
    status: "awaiting-contractor-confirmation",
    backgroundColor: "#c41d7f",
  },
  {
    status: "approved-by-contractor",
    backgroundColor: "#d46b08",
  },
  {
    status: "rejected-by-contractor",
    backgroundColor: "rgb(229, 71, 70)",
  },
  {
    status: "proposed-to-client",
    backgroundColor: "rgb(56, 158, 13)",
  },
  {
    status: "completed",
    color: "#f6ffed",
    backgroundColor: "#2e6f40",
  },
  {
    status: "in_warranty",
    backgroundColor: "#c292fd",
  },
  {
    status: "ongoing",
    backgroundColor: "#096dd9",
  },
  {
    status: "delivered",
    color: "#389e0d",
    backgroundColor: "#f6ffed",
  },
];
